import React from "react";
import { Navigation } from "lucide-react";
import { Button } from "./ui/button";
import { mapHref, isWaze } from "../lib/maps";

export function MapLink({ url, address, label, iconOnly = false, size = "sm", variant = "outline", className = "", testid = "map-link" }) {
  const href = mapHref(url, address);
  if (!href) return null;
  const waze = isWaze(url);
  return (
    <Button
      type="button" size={size} variant={variant} data-testid={testid}
      className={`gap-1.5 rounded-sm ${className}`}
      onClick={(e) => { e.stopPropagation(); window.open(href, "_blank", "noopener"); }}
      title="Abrir ubicación en el mapa"
    >
      <Navigation className="h-4 w-4" />
      {!iconOnly && <span>{label || (waze ? "Abrir en Waze" : "Cómo llegar")}</span>}
    </Button>
  );
}

export default MapLink;
